// NO EDITAR A MANO
// const id = "footer.link_legal.link-configuracion";
const valor = `Privacy Settings`;

export default valor;
